import React from 'react';

import { RowSkeleton } from './row-skeleton';

export const SearchSkeletons = (): React.JSX.Element => {
	return (
		<>
			<RowSkeleton />
			<RowSkeleton />
			<RowSkeleton />
			<RowSkeleton />
			<RowSkeleton />
		</>
	);
};
